import styles from "./Close.module.scss"

export const Close = () => {
    return <div className={styles.container}>
        <span onClick={() => window.close()}>
            &times;
        </span>
    </div >
}